import React from 'react';

const TextArea = ({
  placeholder = '',
  value = '',
  onChange = () => {},
  onBlur = () => {},
  onFocus = () => {},
  label = '',
  error = '',
  disabled = false,
  required = false,
  className = '',
  rows = 3,
  resize = 'vertical',
  ...props
}) => {
  const baseClasses = 'block w-full border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors duration-200 px-3 py-2 text-sm';
  
  const variantClasses = {
    default: 'bg-white',
    error: 'border-red-300 focus:ring-red-500 focus:border-red-500'
  };

  const resizeClasses = {
    none: 'resize-none',
    vertical: 'resize-y',
    horizontal: 'resize-x',
    both: 'resize'
  };

  const textAreaClasses = `
    ${baseClasses}
    ${variantClasses[error ? 'error' : 'default']}
    ${resizeClasses[resize]}
    ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}
    ${className}
  `.trim();

  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      
      <textarea
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        disabled={disabled}
        required={required}
        rows={rows}
        className={textAreaClasses}
        {...props}
      />
      
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default TextArea;
